'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _modal = require('../components/modal/modal.js');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var COOKIE_NAME = 'am-welcome';
var DEFAULT_INIT_DELAY = 1000;

function init(_ref) {
  var el = _ref.el;

  if (_jsCookie2.default.get(COOKIE_NAME)) return false;

  var initialState = getInitialState(el);
  var modal = new _modal.Modal(el);

  setTimeout(function () {
    modal.onOpen();

    _jsCookie2.default.set(COOKIE_NAME, 'true', {
      expires: 3650
    });
  }, initialState.initDelay);
}

function getInitialState(el) {
  return {
    initDelay: el.dataset.initDelay ? parseInt(el.dataset.initDelay) : DEFAULT_INIT_DELAY
  };
}